/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `order` - order
 * * `contract` - contract
 * * `common` - common
 * * `receipt` - receipt
 * * `policy` - policy
 */
export enum OrderMediaCreateCategoryEnum {
  ORDER = 'order',
  CONTRACT = 'contract',
  COMMON = 'common',
  RECEIPT = 'receipt',
  POLICY = 'policy',
}
